/**
 * Front - Widget Header Alerts.
 */

'use strict';

var helper = require('../misc/helpers');

var FrontGDPR = function () {
    $(document).ready((function() {
        this.showCookiesNotice();
    }).bind(this));
};

FrontGDPR.prototype = {
    showCookiesNotice: function() {
        var cookie = helper.getCookie('cookies_notice');

        if (cookie == '1') {
            // The user has already agreed to the cookie policy (and has closed the notice)
            // Do not show the notice again (lifetime: 1 month).
            $('#cookies-notice').hide();
        } else {
            $('#cookies-notice').show();
        }

        $('#cookies-notice .close').on('click', function(e) {
            e.preventDefault();

            helper.setCookie('cookies_notice', 1, 720); // 1 month

            $('#cookies-notice').hide();
        });
    },
};

module.exports = new FrontGDPR();
